module.exports = __webpack_public_path__ + "static/images/i-svip.2751459.png";